import React from "react";
const Spinner = () => {
    return (React.createElement("div", { className: "text-center my-5" },
        React.createElement("div", { className: "spinner-border primary-color", role: "status" },
            React.createElement("span", { className: "visually-hidden" }, "Loading..."))));
};
export default Spinner;
